<template>
    <!-- **************************** -->
    <!-- El encabezado                -->
    <!-- **************************** -->
    <v-app-bar
        v-if="$store.getters['security/isLogedIn']"
        elevate-on-scroll
        fixed
        flat
    >
        <v-app-bar-nav-icon
            
            @click="drawer = !drawer"
        />

        <v-toolbar-title>
            <v-img contain width="80" src="/images/SantaFeTrans.png"></v-img>
            
        </v-toolbar-title>

        <v-spacer></v-spacer>
        {{$store.getters['security/datosUsuario'].username}}

        <v-tooltip bottom color="red"  >
            <template v-slot:activator="{ on }">
                <v-btn
                    class="ml-5"
                    color="red"
                    small
                    text
                    icon
                    v-on="on"
                    @click="cierraSesion"
                >
                    <v-icon>mdi-logout</v-icon>
                </v-btn>
            
            </template>
            
            <span>Cerrar sesión</span>
        </v-tooltip>

        

        <v-tooltip bottom color="blue">
            <template v-slot:activator="{ on }">
                <v-btn
                    color="blue"
                    small
                    text
                    icon
                    :to="{path: '/admin'}"
                    v-on="on"
                >
                    <v-icon>mdi-cog</v-icon>
                </v-btn>
            </template>
            <span>Administrar</span>
        </v-tooltip>


        <!--
        <v-tooltip bottom color="blue" v-if="$store.state.security.roles.includes('ROLE_ADMIN')">
            <template v-slot:activator="{ on }">
                <v-btn
                    color="blue"
                    small
                    text
                    icon
                    :to="{path: '/cirugiatv'}"
                    v-on="on"
                >
                    <v-icon>mdi-television-classic</v-icon>
                </v-btn>
            </template>
            <span>Cirugias (TV)</span>
        </v-tooltip>
        -->

        
    </v-app-bar>
</template>

<script>
export default {
    props:{
        drawerNavega:{
            type:Boolean
        },
    },
    methods:{
        cierraSesion(){
            this.$store.commit('security/CIERRA_SESION')
            //console.log('Cierra sesión')
        }
    },
    computed:{
        drawer:{
            get(){
                return this.drawerNavega
            },
            set(value){
                this.$emit('update:drawerNavega',value)
                
            },
        },
        
    },
}
</script>

<style>

</style>